import React from 'react'
import GrowthCard from '../../components/growthCard'
import { missionData } from '../../utils/fakeData'

const Mission = () => {

    return (
        <div className='max-w-[1350px] h-auto md:h-[1200px] mx-auto px-4 md:pb-60 relative' >
            <div className="grid md:grid-cols-3 grid-cols-1  gap-6 md:mt-16">
                {/* <GrowthCard /> */}
                <div className=""></div>
                <div className="mt-5 text-center">
                    <h3 className='text-dark font-roboto-mono font-bold italic text-[40px] tracking-[6%]' >
                        Our Mission
                    </h3>
                    <p className='text-dark font-quicksand font-medium text-sm mb-4' >
                        Our mission is to provide the modern traveler with an adsaptable travel ecosystem and information database that will suppirt them as a companion in their jorney of discoery
                    </p>
                </div>
                <div className="mt-2 pl-28">
                    {/* <GrowthCard /> */}
                </div>
            </div>

            {/* <div className="grid md:grid-cols-3 grid-cols-2 gap-6 mt-28">
                <GrowthCard />
                <GrowthCard />

                <div className="mt-2 pl-28">
                    <GrowthCard />
                </div>
            </div> */}
            <div className="md:absolute hidden md:block md:mt-1 mt-2 md:top-[15%] md:right-[5%] transform translate-y-[-50%]">
                <GrowthCard item={missionData[0]} />
            </div>

            <div className="md:absolute hidden md:block md:mt-1 mt-2 md:top-[20%] md:left-[5%] transform -translate-y-1/2">
                <GrowthCard item={missionData[1]} />
            </div>

            <div className="md:absolute hidden md:block md:mt-1 mt-2 md:top-[35%] md:right-[40%] transform -translate-y-1/2">
                <GrowthCard item={missionData[2]} />
            </div>

            <div className="md:absolute hidden md:block md:mt-1 mt-2 md:bottom-[2%] md:right-[10%] transform -translate-y-1/2">
                <GrowthCard item={missionData[3]} />
            </div>

            <div className="md:absolute hidden md:block md:mt-1 mt-2 md:bottom-[30%] md:left-[15%] transform translate-y-1/2">
                <GrowthCard item={missionData[4]} />
            </div>


        </div>
    )
}

export default Mission
